export function BoxTitle(props) {
    return (
        <div className="box-title-holder">
            <h2 className="box-title">{props.text}</h2>
            <p className="box-buttons"><span className='min-button'>  __ </span><span className='max-button'> ▣ </span><span className='x-button'> ✖ </span></p>
        </div>
    );
}